import { createGlobalStyle } from 'styled-components';

export default createGlobalStyle`
    body {
      margin: 0; line-height: normal;
    }
:root {

/* fonts */
--typography-body-1: 'Source Sans Pro';
--typography-h3: Bitter;

/* font sizes */
--typography-subtitle-2-size: 14px;
--components-helper-text-size: 12px;
--components-avatar-initials-size: 20px;
--components-button-small-size: 13px;
--components-button-large-size: 15px;
--typography-body-1-size: 16px;
--typography-h5-size: 18px;
--typography-h3-size: 21px;
--typography-h4-size: 24px;
--typography-h2-size: 30px;

/* Colors */
--light-primary-contrast: #fff;
--light-info-main: #0288d1;
--light-primary-main: #197cb3;
--light-primary-shades-50p: rgba(25, 124, 179, 0.5);
--light-info-shades-4p: rgba(2, 136, 209, 0.04);
--text-normal: #111;
--light-action-selected-8p: rgba(1, 16, 18, 0.08);
--light-secondary-shades-4p: rgba(1, 16, 18, 0.04);
--light-other-divider: rgba(0, 0, 0, 0.12);
--color-gray-100: rgba(0, 0, 0, 0.26);
--light-text-disabled: rgba(1, 16, 18, 0.38);
--light-other-filled-input-background: rgba(0, 0, 0, 0.06);
--color-gray-200: rgba(255, 255, 255, 0);
--light-text-secondary: rgba(1, 16, 18, 0.6);
--light-text-primary: rgba(1, 16, 18, 0.9);
--molina-main: #06828f;
--light-success-main: #2e7d32;
--common-grey-400: #bdbdbd;

/* Gaps */
--gap-5xl: 24px;
--gap-smi: 13px;
--gap-5xs: 8px;
--gap-9xs: 4px;
--gap-base: 16px;
--gap-10xs: 3px;
--gap-11xs: 2px;
--gap-7xs: 6px;
--gap-xs: 12px;

/* Paddings */
--padding-5xs: 8px;
--padding-5xl: 24px;
--padding-base: 16px;
--padding-13xl: 32px;
--padding-xs: 12px;
--padding-sm: 14px;
--padding-3xs: 10px;
--padding-3xl: 22px;
--padding-7xs: 6px;
--padding-9xs: 4px;
--padding-10xs: 3px;
--padding-4xs: 9px;
--padding-xl: 20px;
--padding-29xl: 48px;
--padding-11xs: 2px;
--padding-6xs: 7px;
--padding-6xs-5: 6.5px;

/* Border radiuses */
--br-10xs: 3px;
--br-45xl: 64px;
--br-5xs: 8px;
--br-9xs: 4px;
--br-81xl: 100px;
--br-base: 16px;
--br-29xl: 48px;

/* Effects */
--elevation-2-error: 0px 0px 3px 3px rgba(211, 47, 47, 0.2), 0px 2px 2px 3px rgba(211, 47, 47, 0.14), 0px 1px 5px 3px rgba(211, 47, 47, 0.12);
--elevation-2: 0px 2px 7px rgba(1, 16, 18, 0.15);
}
`;
